module.exports = __webpack_public_path__ + "img/70.7511d138.jpg";